module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacettedConnections.c1607c5.jpg";